export class CoilRequest {

  EnteringDryBulb!: number;
  EnteringWetBulb!: number;
  RowCount!: number;
  TemperatureChange!: number;
  FlowRate!: number;
  FluidType!: string;
  EnteringFluidTemperature!: number;
  ElectricHeatKilowatts!: number;
  ElectricHeatVoltage!: string;
  EnteringSteamPressure!: number;
  GlycolPercentage!: number;
  SaturationSuctionTemperature!: number;
  NumberOfCircuits!: number;
  isRefrigerant!: boolean;
  isSteam!: boolean;
  isFluid!: boolean;
  isCooling!: boolean;
  isElectricHeat!: boolean;
  FinsPerInch!: number;

}
